import { render, staticRenderFns } from "./LogInspector.vue?vue&type=template&id=246bd404&scoped=true"
import script from "./LogInspector.vue?vue&type=script&lang=js"
export * from "./LogInspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246bd404",
  null
  
)

export default component.exports